import React, { memo, useState } from 'react';

export const HelpModal = memo(() => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const toggleModalVisibility = () => {
    setIsModalVisible(!isModalVisible);
  };

  return (
    <>
      {/* Modal Trigger Button */}
      <button
        onClick={toggleModalVisibility}
        className="rounded-full bg-transparent hover:bg-gray-200 p-2"
        style={{
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
        }}
      >
        ?
      </button>

      {/* Modal */}
      {isModalVisible && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full"
          onClick={toggleModalVisibility}
        >
          <div
            className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white"
            onClick={(e) => e.stopPropagation()} // Prevent click from closing modal
            style={{
              backdropFilter: 'blur(10px)',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            }}
          >
            <div className="mt-3 text-center">
              <h3 className="text-lg leading-6 font-medium text-gray-900">How to Use</h3>
              <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-500">
                  Use the JQL box to enter your query and press 'Enter' to apply. Once you're ready,
                  refresh the data with the top right icon and proceed to select versions of
                  interest.
                </p>
              </div>
              <div className="items-center px-4 py-3">
                <button
                  id="ok-btn"
                  className="px-4 py-2 bg-blue-500 text-white text-base font-medium rounded-md w-full shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-300"
                  onClick={toggleModalVisibility}
                >
                  Got It!
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
});
